document.addEventListener("DOMContentLoaded", ()=>{
    const appDiv = document.getElementById("app");
    const routes = {
        "/": "../src/accueil.html",
        "/artistes": "../src/artistes.html",
        "/billetterie": "../src/billetterie.html",
        "/informations": "../src/informations.html",
        "/benevolat": "../src/benevolat.html"
    };
    function loadContent(url) {
        fetch(url).then((response)=>response.text()).then((html)=>{
            appDiv.innerHTML = html;
            window.scrollTo(0, 0);
        }).catch((error)=>{
            appDiv.innerHTML = "<h1>Page not found</h1>";
        });
    }
    function onNavigate(event) {
        event.preventDefault();
        const path = event.target.getAttribute("href");
        window.history.pushState({}, path, window.location.origin + path);
        loadContent(routes[path]);
    }
    window.onpopstate = ()=>{
        loadContent(routes[window.location.pathname]);
    };
    document.querySelectorAll("nav a").forEach((anchor)=>{
        anchor.addEventListener("click", onNavigate);
    });
    // Initial load
    loadContent(routes[window.location.pathname]);
});

//# sourceMappingURL=index.206f4afd.js.map
